import { FlexContainer, Text, textColors } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { stages } from 'Constants/stages';
import { ResultTypes } from 'Types/common';

export const ColorByResult = {
  [ResultTypes.toReturn]: textColors.success_strong,
  [ResultTypes.toPay]: textColors.cold,
  [ResultTypes.equal]: textColors.grey,
  [ResultTypes.zero]: textColors.grey,
};

export const ColorByStage = {
  [stages.FINISHED_MISSING_CLABE]: textColors.warning_strong,
  [stages.FINISHED_AUTOMATIC_NOT_SUCCESS]: textColors.warning_strong,
  [stages.FINISHED_PAYMENT_ISSUED]: textColors.warning_strong,
  [stages.TAX_AGENCY_CLABE_ISSUED]: textColors.warning_strong,
  [stages.SUBMITTED_CHANGED_WAITING_USER_RESPONSE]: textColors.warning_strong,
  [stages.INVALID_SAT_CLABE]: textColors.warning_strong,
  [stages.AUTOMATIC_PAYMENT_FAILED]: textColors.warning_strong,
};

export const AmountResolved = styled(Text)<{
  $resultType: keyof typeof ResultTypes;
  $stage: keyof typeof stages;
}>`
  color: ${({ $resultType, $stage }) =>
    $stage && ColorByStage[$stage] ? ColorByStage[$stage] : ColorByResult[$resultType]};
`;

export const ResultInfoContainer = styled(FlexContainer)`
  margin-bottom: ${({ theme: { reference } }) => reference.dimension_08};
`;
